import { Paper } from '@mui/material'
import { useEffect } from 'react'
import { useStoreActions, useStoreState } from '../../../store/hooks'

import { pixelSizings } from '../../../components/AppLayout/AppLayout'
import { default as GameHistoryContent } from '../../Profile/components/GameHistory'
import { GuestBlocker } from '../components/missions/GuestBlocker'

export const GameHistory = () => {
    const settings = useStoreState((state) => state.gameView.settings)
    const user = useStoreState((state) => state.userData)
    const initStats = useStoreActions((state) => state.profileView.initStats)

    useEffect(() => {
        initStats()
    }, [settings.friendlyMode, user.userData?.id])

    return (
        <Paper
            sx={{
                display: 'flex',
                flexGrow: 1,
                height: {
                    xs: `calc(100dvh - ${pixelSizings.margin}/2  - ${pixelSizings.mobileHeader})`,
                    md: `calc(100vh - ${pixelSizings.margin} - ${pixelSizings.desktopHeader})`,
                },
                overflow: 'auto',
                position: 'relative',
                backgroundColor: 'transparent',
            }}
        >
            <GuestBlocker variant="gameHistory" />
            <GameHistoryContent />
        </Paper>
    )
}
